module.exports = __webpack_public_path__ + "teg/media/adani.d906d6cf.png";